var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a4c5os3mja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1295H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bvu21x91tb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.954 0 0 6.971 2.05 0h2.904z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f5jw5rjfkd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.574 0 1.101 2.028H0L1.574 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qzigq31ayf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.102 0 1.573 2.028H0L1.102 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wd8a4wvfqh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.904 0 2.05 6.971L0 0h2.904z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zi4axo87rj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.026 0 1.911 2.053 0 0h3.026z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7kxbr3ni2l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.026 0 1.115 2.053 0 0h3.026z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq4md0qeum"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.337 0 2.168 7.373 0 0h4.337z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46odfr54no"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.954 0 1.954 2.099H0L1.954 0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p1kqsa7cwc",
    x1: 6.073,
    y1: 3.486,
    x2: 0,
    y2: 3.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "za8r6es3pe",
    x1: 3.28,
    y1: 1.014,
    x2: 0,
    y2: 1.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7r8h1zvwig",
    x1: 3.28,
    y1: 1.014,
    x2: 0,
    y2: 1.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "97y9c3kqri",
    x1: 6.073,
    y1: 3.486,
    x2: 0,
    y2: 3.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rsri50b7sk",
    x1: 3.71,
    y1: 1.026,
    x2: 0,
    y2: 1.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mi7k2ro86n",
    x1: 5.316,
    y1: 3.686,
    x2: 0,
    y2: 3.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qk0ruel0ap",
    x1: 4.791,
    y1: 1.049,
    x2: 0,
    y2: 1.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4c5os3mja)",
    transform: "translate(-932 -116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bvu21x91tb)",
    transform: "translate(938.046 118.627)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p1kqsa7cwc)",
    d: "M0 0h4.954v6.971H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f5jw5rjfkd)",
    transform: "translate(932.023 116.161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#za8r6es3pe)",
    d: "M0 0h2.675v2.028H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qzigq31ayf)",
    transform: "translate(940.301 116.161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#7r8h1zvwig)",
    d: "M0 0h2.675v2.028H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wd8a4wvfqh)",
    transform: "translate(932 118.627)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#97y9c3kqri)",
    d: "M0 0h4.954v6.971H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zi4axo87rj)",
    transform: "translate(937.992 116)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#rsri50b7sk)",
    d: "M0 0h3.026v2.053H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7kxbr3ni2l)",
    transform: "translate(933.982 116)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#rsri50b7sk)",
    d: "M0 0h3.026v2.053H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq4md0qeum)",
    transform: "translate(935.332 118.627)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#mi7k2ro86n)",
    d: "M0 0h4.337v7.373H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46odfr54no)",
    transform: "translate(935.546 116.09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#qk0ruel0ap)",
    d: "M0 0h3.908v2.099H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.c56979777a5969a0e5d61ca8f267741e.svg";
export { ForwardRef as ReactComponent };